import { defineStore } from 'pinia'
import { ref } from "vue";

export const useAppConfigStore = defineStore('appConfig', () => {
    const appConfig = ref({});

    const setAppConfig = (data) => {
        appConfig.value = data;
    }

    return {
        appConfig,
        setAppConfig,
    }
})
